import { http } from 'src/utils/http.util'
import { TUserProject } from 'src/types/user'
import { TUserProjectForm } from 'src/pages/medical/users/_components/users-table.component'

export const UserProjectService = {
  getUserProjectList: async (projectId: number): Promise<Array<TUserProject>> => {
    return http.get(`/projects/${projectId}/users`).then((res) => res.data)
  },

  inviteUserProject: async (
    projectId: number,
    UserProject: TUserProjectForm & { User: TUserProjectForm['User'] & { password: string } },
  ): Promise<TUserProject> => {
    return http.post(`/projects/${projectId}/users/invite`, UserProject).then((res) => res.data)
  },

  updateUserProject: async (
    projectId: number,
    UserProject: TUserProjectForm,
    isEditableUser?: boolean,
  ): Promise<TUserProject> => {
    // UserId & isEmailVerified must not be part of the body
    const { UserId, User, ...body } = UserProject
    return Promise.all([
      http.put(`/projects/${projectId}/users/${UserId}`, {
        ...body,
      }),
      isEditableUser &&
        http.put(`/users/${UserId}`, {
          ...User,
          isEmailVerified: undefined,
          role: undefined,
        }),
    ]).then(([updateUserProjectRes, updateUserRes]) => {
      const UserProject = updateUserProjectRes.data
      const destructuredUser = updateUserRes
        ? {
            email: updateUserRes.data.email,
            firstname: updateUserRes.data.firstname,
            lastname: updateUserRes.data.lastname,
            locale: updateUserRes.data.locale,
            phone: updateUserRes.data.phone,
            title: updateUserRes.data.title,
            isEmailVerified: updateUserRes.data.isEmailVerified,
          }
        : undefined
      return {
        ...UserProject,
        User: destructuredUser ?? UserProject.User,
      }
    })
  },

  deleteUserProject: async (projectId: number, userId: number): Promise<Pick<TUserProject, 'UserId'>> => {
    return http.delete(`/projects/${projectId}/users/${userId}`).then((res) => res.data)
  },
}
